<script>
  export let text = '';
  export let done = false;
  export let current = false;
</script>

<style>
  .circle {
    fill: rgba(0, 0, 0, 0.38);
    font-size: 13px;
    font-weight: bold;
    margin: 8px;
  }

  .circle.current {
    fill: #dd5900;
  }

  .circle.done {
    fill: #28a745;
  }
</style>

<svg class="circle" class:done class:current height="24" width="24">
  {#if !done}
    <circle cx="12" cy="12" r="12" />
    <text fill="white" x="8.5" y="16">{text}</text>
  {:else}
    <path
      d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6
      3.6 7.6-7.6L19 8l-9 9z" />
  {/if}
</svg>
